import React, { useEffect, useState } from 'react';
import { List } from 'immutable';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { DateRange } from 'react-date-range';
import { format } from 'date-fns';


import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  View,
} from '@uncinc/react-drupal-core';
import {
  getVocabulary,
} from '../../store/actions/UI';

import './style.scss';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const LatestArticles = ({ id, entity, isForMunicipalities = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const DATE_RANGE_COLOR_CODE = '#f84f37';
  const [currentPage, setCurrentPage] = useState(0);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const articleFilter = urlParams.get('type');
  const showLess = entity.getIn(['field_show_less', 0, 'value'], false);
  const [articleTypeFilter, setArticleTypeFilter] = useState(articleFilter);

  const [openDatePicker, setOpenDatePicker] = useState(false);
  const terms = useSelector((state) => state.getIn(['uiInternal', 'vocabularies', 'article_types'], List()));
  const mappedTerms = List([{ value: null, label: t('general.all') }])
    .merge(terms.filter((term) => !term.getIn(['field_filter_hidden', 0, 'value'], false)).map((term) => {
      return {
        value: term.getIn(['tid', 0, 'value']),
        label: term.getIn(['name', 0, 'value']),
      };
    }));

  const [selectionRange, setSelectionRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ]);

  const [filtersDateRange, setFiltersDateRange] = useState([null, null]);
  const [appliedFilters, setAppliedFilters] = useState({});

  useEffect(() => { dispatch(getVocabulary('article_types')); }, [dispatch]);

  useEffect(() => {
    const filters = {};

    if (filtersDateRange[0] && filtersDateRange[1]) {
      filters.field_publication_date_value = {
        min: `${filtersDateRange[0].getFullYear()}-${(filtersDateRange[0].getMonth() + 1).toString().padStart(2, '0')}-${filtersDateRange[0].getDate().toString().padStart(2, '0')} 00:00:00`,
        max: `${filtersDateRange[1].getFullYear()}-${(filtersDateRange[1].getMonth() + 1).toString().padStart(2, '0')}-${filtersDateRange[1].getDate().toString().padStart(2, '0')} 23:59:59`,
      };
    }

    setAppliedFilters(filters);
  }, [filtersDateRange]);

  const handleSelect = (ranges) => {
    setSelectionRange([ranges.selection]);
    setFiltersDateRange([ranges.selection.startDate, ranges.selection.endDate]);
  };

  let displayDate = t('filters.select_date_range');
  if (selectionRange[0].endDate) {
    displayDate = `${format(selectionRange[0].startDate, 'dd/MM/yyyy')} - ${format(selectionRange[0].endDate, 'dd/MM/yyyy')}`;
  }

  return (
    <div id={id} className="ParagraphLatestArticles">

      {/* Start Filters */}
      <Container>
        <div className="row ParagraphLatestArticles__filters">
          {/* Article time period */}
          <div className="col-12 col-md-6 col-lg-4 dropdown-holder">
            <b>{t('filters.article_date.placeholder')}</b>
            <div
              className={`ParagraphLatestArticles__select ${openDatePicker ? 'hidden' : ''}`}
              onClick={() => setOpenDatePicker(true)}>
              <div className="placeholder">{displayDate}</div>
              <div className="icon icon-calendar icon-variant-0" />
            </div>
            <div
              className={`ParagraphLatestArticles__datepicker__wrapper ${!openDatePicker ? 'hidden' : ''}`}
              onClick={() => setOpenDatePicker(false)} />
            <div className={`ParagraphLatestArticles__datepicker ${!openDatePicker ? 'hidden' : ''}`}>
              <DateRange
                ranges={[selectionRange[0]]}
                onChange={(ranges) => handleSelect(ranges)}
                rangeColors={[DATE_RANGE_COLOR_CODE]}
                color={DATE_RANGE_COLOR_CODE}
              />
            </div>
          </div>

          {/* Article types select */}
          {!isForMunicipalities && (
            <div className="col-12 col-md-6 col-lg-4 dropdown-holder">
              <b>{t('filters.article_type.placeholder')}</b>
              <Select
                placeholder={t('filters.select_type')}
                options={mappedTerms}
                className="Select"
                classNamePrefix="Select"
                onChange={(e) => {
                  setArticleTypeFilter(e.value);
                  setCurrentPage(0);
                }}
              // eslint-disable-next-line react/jsx-boolean-value
              />
            </div>
          )}
        </div>
      </Container>
      {/* End Filters */}

      {/* Start Content */}
      <View
        className="ParagraphLatestArticles__view"
        page={currentPage}
        args={articleTypeFilter ? [articleTypeFilter] : ['all']}
        filters={appliedFilters}
        id="latest_articles"
        setCurrentPage={setCurrentPage}
        display={isForMunicipalities
          ? showLess ? 'block_3' : 'block_2'
          : 'block_1'}
      />
      {/* End Content */}

    </div>
  );
};

export default LatestArticles;
